import { err, ok } from 'neverthrow'
import { getExtension } from 'mime'

export const dataURIToBlob = (dataURI: string) => {
  const [mimeAndEncoding, data] = dataURI.split(/[,:]/).slice(1)
  const [mimetype, encoding] = mimeAndEncoding.split(';')

  if (!['base64', undefined].includes(encoding))
    return err(`Unsupported DataURI encoding: ${encoding}.`)
  if (data === undefined) return err('Empty DataURI data.')
  if (typeof getExtension(mimetype) !== 'string')
    return err(`Unsupported DataURI mimetype: ${mimetype}.`)

  const validBase64 = dataURI.includes('base64,')
    ? dataURI.split('base64,')[1]
    : dataURI
  return ok(b64toBlob(validBase64, mimetype))
}

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays: Uint8Array[] = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}
